module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/sunbum-logo-50c80738826bb65efd981cf9b3c84e14.svg";